<template>
  <answer-template
    :answer-type="'category'"
    :input-data="inputData"
    :data-category="dataCategory"
    :index="index"
    :wrapper-class="'change-rule'"
    @deleted="$emit('deleted')"
  >
    <template v-slot:label>Category name</template>
    <template v-slot:content>
      <div class="field">
        <div class="control is-expanded">
          <div class="is-small is-fullwidth">
            {{ dataCategory }}
          </div>
        </div>
      </div>
    </template>
  </answer-template>
</template>
<script>
import AnswerTemplate from '../Answers/AnswerTemplate.vue';

export default {
  name: 'modelCategory',
  components: {
    AnswerTemplate,
  },
  props: {
    inputData: {
      type: Object,
      default() {
        return {
          type: '',
          ruleId: '',
        };
      },
    },
    dataCategory: {
      type: String,
    },
    isFirst: {
      type: Boolean,
      default: true,
    },
    isLast: {
      type: Boolean,
      default: true,
    },
    index: {
      type: Number,
    },
  },
  mounted() {
  },
  data() {
    return {
    };
  },
  methods: {
    getLevelDash(level) {
      switch (level) {
        case 1: return '&ensp;';
        case 2: return '&ensp;&ensp;';
        case 3: return '&ensp;&ensp;&ensp;';
        case 4: return '&ensp;&ensp;&ensp;&ensp;';
        default: return '';
      }
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
